import { noop } from 'lodash';
import { createContext } from 'utils/react';

export default createContext('Toggleable', {
    isOpen: false,
    onBeforeOpen: noop,
    onOpen: noop,
    onBeforeClose: noop,
    onClose: noop,
    open: noop,
    close: noop,
    toggle: noop,
});
